import React from "react"
import { createPortal } from "react-dom"
import * as modalCss from "./modules/book-preview-modal.module.scss"

const BookPreviewModal = ({ book, onClose }) => {
  const closeButtonRef = React.useRef(null)

  React.useEffect(() => {
    if (!book) return undefined

    const previousFocus = document.activeElement
    const previousOverflow = document.body.style.overflow

    document.body.style.overflow = "hidden"
    closeButtonRef.current?.focus()

    const handleKeyDown = event => {
      if (event.key === "Escape") {
        onClose()
        return
      }

      if (event.key !== "Tab") return

      const panel = closeButtonRef.current?.closest('[role="dialog"]')
      const focusableElements = panel?.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )

      if (!focusableElements?.length) return

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault()
        lastElement.focus()
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault()
        firstElement.focus()
      }
    }

    document.addEventListener("keydown", handleKeyDown)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
      document.body.style.overflow = previousOverflow
      previousFocus?.focus()
    }
  }, [book, onClose])

  if (!book || typeof document === "undefined") return null

  return createPortal(
    <div
      className={modalCss.overlay}
      onClick={event => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      <section
        className={modalCss.panel}
        role="dialog"
        aria-modal="true"
        aria-labelledby="book-preview-title"
        aria-describedby="book-preview-description"
      >
        <button
          ref={closeButtonRef}
          className={modalCss.close}
          type="button"
          onClick={onClose}
        >
          Fermer
        </button>

        <figure className={modalCss.visual}>
          <img src={book.cover} alt={book.coverAlt} />
        </figure>

        <div className={modalCss.content}>
          <p className={modalCss.collection}>Collection Lefevre-Vakana</p>
          <h2 id="book-preview-title">{book.title}</h2>
          {book.period && <p className={modalCss.period}>{book.period}</p>}
          <p id="book-preview-description" className={modalCss.description}>
            {book.description}
          </p>

          {book.details.length > 0 && (
            <dl className={modalCss.details}>
              {book.details.map(detail => (
                <div key={detail.label}>
                  <dt>{detail.label}</dt>
                  <dd>{detail.value}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      </section>
    </div>,
    document.body
  )
}

export default BookPreviewModal
